const { debounce } = window.BAO.Utils

const KeenSlider = window.KeenSlider

const { setInitialised } = window.BAO.Carousel.plugins

class ProductCard extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['slides', 'slide']
  }

  setupListeners () {
    super.setupListeners()

    if (
      this.els?.slide?.elements?.length < 2 ||
      this.dataset.carouselDisabledMobile === 'true'
    ) {
      return
    }

    this.initialiseCarousel = this.initialiseCarousel.bind(this)
    this.listeners.add(window, 'load', this.initialiseCarousel)

    this.onResize = this.onResize.bind(this)
    this.listeners.add(window, 'resize', debounce(this.onResize, 100))

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.GRID_SWITCHER.SWITCHED_COLUMNS,
      this.reset.bind(this),
    )
  }

  connectedCallback () {
    super.connectedCallback()
  }

  initialiseCarousel () {
    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        loop: true,
        mode: 'snap',
        rubberband: false,
        defaultAnimation: {
          duration: 800,
        },
        dragSpeed: 0.8,
        slides: {
          perView: 1,
        },
        breakpoints: {
          '(max-width: 900px)': {
            disabled: false,
          },
          '(min-width: 901px)': {
            disabled: true,
          },
        },
      },
      [setInitialised()],
    )
  }

  onResize () {
    this.reset()
  }

  reset () {
    if (this.carousel) {
      this.carousel.destroy()
    }

    this.carousel = this.setupCarousel()
  }
}

if (!customElements.get('product-card')) {
  customElements.define('product-card', ProductCard, {
    extends: 'article',
  })
}
